//constants
import {
  ALERT_ACTION,
  CREATE_ALERT_ACTION,
  DELETE_ALERT_ACTION,
} from "./Constants";

const INITIAL_STATE = {
  alertsData: {
    alert_for_self_info: {},
    alerts: [],
    allowed_alerts_count: "",
  },
  createAlertData: {
    error: null,
    data: {},
  },
  deleteAlertData: { error: null, data: null },
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case ALERT_ACTION:
      return {
        ...state,
        alertsData: {
          alert_for_self_info: action.response.alert_for_self_info
            ? { ...action.response.alert_for_self_info }
            : {},
          alerts: action.response.alerts ? [...action.response.alerts] : [],
          allowed_alerts_count: action.response.allowed_alerts_count,
        },
      };
    case CREATE_ALERT_ACTION:
      return {
        createAlertData: {
          error: action.error,
          data: action.data,
        },
      };

    case DELETE_ALERT_ACTION:
      return {
        deleteAlertData: {
          error: action.error,
          data: action.data,
        },
      };

    default:
      return state;
  }
}
